import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-1dc6d8f5")

_pushScopeId("data-v-1dc6d8f5")
const _hoisted_1 = {
  class: "flex flex-col h-screen overflow-auto relative",
  style: {"height":"calc(calc(100vh / var(--viewport-scale)) - 2rem)"}
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_breadcrumb = _resolveComponent("breadcrumb")!
  const _component_lp_button = _resolveComponent("lp-button")!
  const _component_TableV2 = _resolveComponent("TableV2")!
  const _component_detail_layout = _resolveComponent("detail-layout")!
  const _component_WidgetDownload = _resolveComponent("WidgetDownload")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", _hoisted_1, [
      _createVNode(_component_breadcrumb, { "custom-breadcrumb-title": _ctx.title }, null, 8, ["custom-breadcrumb-title"]),
      _createVNode(_component_detail_layout, {
        title: 
        `
       ${_ctx.title} (${_ctx.totalDisplay})`
      ,
        fullPage: true,
        verticalSeparator: false,
        onBack: _ctx.goBack,
        error: _ctx.isError,
        errorType: _ctx.errorCause,
        onTryAgain: _ctx.onRequest,
        customClass: "pt-6"
      }, {
        "top-right": _withId(() => [
          (
            _ctx.showButtonDownload && (_ctx.totalData !== 0 || _ctx.detailData.total !== 0)
          )
            ? (_openBlock(), _createBlock(_component_lp_button, {
                key: 0,
                custom: "px-6 py-2 bg-red-lp-200 font-normal",
                title: "Download",
                onClick: _ctx.onDownload,
                textColor: "white",
                iconLeft: "document-download-outline-white"
              }, null, 8, ["onClick"]))
            : _createCommentVNode("", true)
        ]),
        data: _withId(() => [
          _createVNode(_component_TableV2, {
            columns: _ctx.columns,
            data: _ctx.listData,
            loading: _ctx.isLoading,
            pagination: _ctx.pagination,
            "onUpdate:pagination": _cache[1] || (_cache[1] = ($event: any) => (_ctx.pagination = $event)),
            paginationStyle: "v3",
            borderTop: false,
            borderBottom: false,
            isNoPaddingBottom: true,
            onRequest: _ctx.onRequest,
            isPinnedScrollBottom: "",
            pinnedSubstractHeight: "250px",
            paginationWidth: _ctx.isFromOutsideDashboard ? 'w-3/4' : ''
          }, null, 8, ["columns", "data", "loading", "pagination", "onRequest", "paginationWidth"])
        ]),
        _: 1
      }, 8, ["title", "onBack", "error", "errorType", "onTryAgain"])
    ]),
    (_ctx.isFromOutsideDashboard && (_ctx.detailData.total !== 0 || _ctx.totalData !== 0))
      ? (_openBlock(), _createBlock(_component_WidgetDownload, { key: 0 }))
      : _createCommentVNode("", true)
  ], 64))
})